import { createFileRoute } from '@tanstack/react-router';
import DripContactsPage from '../../views/dashboard-drip/contacts';

export const Route = createFileRoute('/dashboard/drip/contacts/')({
  component: DripContactsPage,
});
